export default __webpack_public_path__ + "static/media/googleLogo.330a2dc7.svg";